import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';

import type { DialogComponentI } from '@core/user-interface-legacy';
import { DialogRef } from '@core/user-interface-legacy';

import { Step } from '../../security.types';
import { SmsActivationStep1Component } from './sms-activation-step-1/sms-activation-step-1.component';
import { SmsActivationStep2Component } from './sms-activation-step-2/sms-activation-step-2.component';

@Component({
  selector: 'rt-sms-activation-dialog',
  templateUrl: './sms-activation-dialog.component.html',
  styleUrls: ['./sms-activation-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SmsActivationStep1Component, SmsActivationStep2Component],
})
export class SmsActivationDialogComponent implements DialogComponentI<{}, undefined> {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dialogRef = inject(DialogRef);

  public phoneNumber: string;
  public step: Step = Step.One;
  public Step: typeof Step = Step;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData() {}

  public goToStepTwo(phoneNumber: string) {
    this.phoneNumber = phoneNumber;
    this.changeStep(Step.Two);
  }

  public changeStep(step: Step): void {
    this.step = step;
    this.cdRef.detectChanges();
  }

  public activated(): void {
    this.dialogRef.close();
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
